import { SessionInfo } from './SessionInfo'
import { StudentsInfo } from './StudentsInfo'
import { regularSessionHelper } from 'src/libs/role-permission.helper'
import SessionTrackControl from 'src/components/class/regular/edit/SessionTrackControl'
import { useGetCategories } from 'src/hooks/useGetCategoriesV2'
import { CATEGORY_TYPE } from 'src/libs/constant'
import { useMemo } from 'react'
import { HomeworkInfo } from './HomeworkInfo/HomeworkInfo'
import statisticReportApi from 'src/api/statisticsReport'
import useGetWithContext from 'src/hooks/useGetWithContext'
import { SessionContent } from 'src/components/statistics-report/StatisticsReportDetail'
import { CollapseBlock } from 'src/components/common/other/CollapseBlock'
import { useTranslation } from 'next-i18next'
import { getSearchQuery } from 'src/libs/util'

export function RegularSessionDetail ({ data, dataHomework, dataStudents, handleReload, serverRuntimeConfig }) {
  const { t } = useTranslation()
  const { id } = getSearchQuery()
  const { getCategoryData: getTimeSlot } = useGetCategories(
    CATEGORY_TYPE.CLASS_TIME_SLOT
  )
  const timeSlot = useMemo(() => {
    return getTimeSlot(data?.classTimeSlotId)
  }, [data])
  const validationValues = regularSessionHelper(data, timeSlot)
  const { data: lessonContentData } = useGetWithContext(
    `GET_LESSON_CONTENT_BY_SESSION_ID_${id}`,
    statisticReportApi.getLessonContentBySessionId,
    id,
    { isDisabled: !id }
  )
  return (
    <>
      <SessionInfo
        classData={data}
        handleReload={handleReload}
        validationValues={validationValues}
        serverRuntimeConfig={serverRuntimeConfig}
      />
      <StudentsInfo
        classData={data}
        handleReload={handleReload}
        validationValues={validationValues}
        dataStudents={dataStudents}
      />
      <HomeworkInfo
        classData={data}
        dataHomework={dataHomework}
        handleReload={handleReload}
        validationValues={validationValues}
      />

      <SessionTrackControl/>
      {/* {lessonContentData && ( */}
      <CollapseBlock
        header={t('page.statistics_report.label.session_content')}
      >
        <SessionContent lessonContent={lessonContentData} isDisabledTitle/>
      </CollapseBlock>
      {/* )} */}

    </>
  )
}
